export enum ChannelStatus {
  Idle = 'idle',
  Connecting = 'connecting',
  Connected = 'connected',
  Rejected = 'rejected',
  Disconnected = 'disconnected',
}

export interface UseActionCableProps<T = unknown> {
  channel: string
  params?: Record<string, unknown>
  onMessage?: (message: T) => void
  enabled?: boolean
}

export interface UseActionCableReturn {
  status: ChannelStatus
}
